import * as React from "react";
import { $, merge } from "glamor";
import theme from "styles/theme";
import { TopLevelToggle } from "./types";
import { MetricsSwitch } from "./metrics-switch";
import { connect } from "react-redux";
import { MetricsListContainer } from "./metrics-list-container";
import { useFlags } from "launchdarkly-react-client-sdk";
import { IStore } from "reducers";
import { toggleAssortmentTotals, togglePlanTotals } from "actions/tool-panel/draft/actions";
import { useDimensionPanelContext } from "../../dimensions-tool-panel";
import { DATATEST } from "constants/integration";

const styles = merge(
    $(" .MuiTypography-body1", {
        fontSize: "14px",
        fontFamily: "Lato",
    }),
    $(" .form-label", {
        margin: "0 4px",
        height: "28px",
        width: "100%",
    }),
    $(" .metrics-list", {
        marginTop: "20px",
    }),
    $(" .spacer-top", {
        marginTop: "20px",
    }),
    $(" .section", {
        margin: "10px",
        padding: "6px",
    }),
    $(" .section-switch", {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    }),
    $(" .header", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }),
    $(" .MuiSvgIcon-root", {
        color: theme.palette.primary1Color,
    }),
    $(" .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track", {
        backgroundColor: theme.palette.primary1Color,
    }),
    $(" .MuiSwitch-thumb", {
        backgroundColor: theme.palette.primary1Color,
    })
);

export const MetricsTab = ({
    showAssortmentTotals,
    showPlanTotals,
    toggleAssortmentTotals,
    togglePlanTotals,
    toggleShowOn,
}) => {
    const { rollupAverageUnitsEnabled, metricsShowPlans: canShowPlan } = useFlags();
    const { isRollupMode } = useDimensionPanelContext();
    const hideToggle = isRollupMode && rollupAverageUnitsEnabled;

    return (
        <div {...styles} className="metrics-wrapper">
            {!hideToggle && (
                <MetricsSwitch
                    className="form-label spacer-top"
                    checked={showAssortmentTotals}
                    label={TopLevelToggle.showAssortmentTotals}
                    dataTestName={DATATEST.TOOL_PANEL.DOORS.METRICS.TOTAL_SWITCH}
                    onChange={() => toggleAssortmentTotals({ showAssortmentTotals: !showAssortmentTotals })}
                />
            )}
            {canShowPlan && (
                <MetricsSwitch
                    className="form-label spacer-top"
                    checked={showPlanTotals}
                    label={TopLevelToggle.showPlan}
                    dataTestName={DATATEST.TOOL_PANEL.DOORS.METRICS.PLAN_SWITCH}
                    onChange={() => togglePlanTotals({ showPlanTotals: !showPlanTotals })}
                />
            )}
            <MetricsListContainer
                rollupAverageUnitsEnabled={rollupAverageUnitsEnabled}
                isRollupMode={isRollupMode}
                toggleShowOn={toggleShowOn}
            />
        </div>
    );
};

export const MetricsTabContainer = connect(
    (state: IStore) => ({
        showAssortmentTotals: state.dimensionsPanel.draft.metrics.showAssortmentTotals,
        showPlanTotals: state.dimensionsPanel.draft.metrics.showAssortmentPlan,
    }),
    { toggleAssortmentTotals, togglePlanTotals }
)(MetricsTab);
